export default __webpack_public_path__ + "1c45a6c0d40f1ef563f021f063eabdcb.png";